import React, { useEffect } from 'react'
import { css } from '@emotion/core'
import * as ReportModel from '@/models/report'
import dayjs from 'dayjs'
import { useAppDispatch, useAppSelector } from '@/features/hooks'
import { fetchReportHistory } from '@/features/report-manager/report-manager-thunks'

export const ExportHistory: React.FC = () => {
  const dispatch = useAppDispatch()
  const { hasExportInProgress, exportHistories } = useAppSelector(state => state.reportManager)

  const renderReportStatusCol = (status: ReportModel.ExportStatus) => {
    if (status === ReportModel.ExportStatus.success) {
      return <>完了</>
    }
    if (status === ReportModel.ExportStatus.error) {
      return <>失敗</>
    }
    return <>処理中</>
  }

  useEffect(() => {
    dispatch(fetchReportHistory())
  }, [])

  useEffect(() => {
    if (!hasExportInProgress) {
      return
    }
    const interval = setInterval(() => {
      dispatch(fetchReportHistory())
    }, 1000)
    return () => clearInterval(interval)
  }, [hasExportInProgress])

  return (
    <div css={componentStyle}>
      <h1>出力履歴</h1>
      <div>
        <table>
          <thead>
            <tr>
              <th className="col-created-at">作成日時</th>
              <th className="col-format">形式</th>
              <th className="col-period">期間</th>
              <th className="col-name">レポート名</th>
              <th className="col-export-status">ステータス</th>
            </tr>
          </thead>
          <tbody>
            {exportHistories.length === 0 && (
              <tr>
                <td colSpan={5}>出力履歴がありません</td>
              </tr>
            )}
            {exportHistories.map(history => (
              <tr key={`export-history-${history.id}`}>
                <td className="col-created-at">{dayjs(history.createdAt).format('YYYY/MM/DD HH:mm')}</td>
                <td className="col-format">{history.format}</td>
                <td className="col-period">{history.period}</td>
                <td className="col-name">
                  {history.url ? (
                    <a href={history.url} target="_blank" rel="noreferrer">
                      {history.name}
                    </a>
                  ) : (
                    history.name
                  )}
                </td>
                <td className="col-export-status">{renderReportStatusCol(history.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const componentStyle = css({
  marginTop: 32,
  width: '100%',
  height: '100%',
  background: '#FFF',
  boxShadow: '0px 0px 6px #0000001a',
  borderRadius: 5,

  h1: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#272727',
    lineHeight: '50px',
    paddingLeft: 32,
  },
  table: {
    width: '100%',
    'th,td': {
      ':first-of-type': { paddingLeft: 32 },
    },
    thead: {
      backgroundColor: '#f5f5f5',
      lineHeight: '32px',
      color: 'rgb(103, 103, 103)',
      fontSize: 12,
      fontWeight: 'bold',
    },
    tbody: {
      fontSize: 14,
      tr: {
        lineHeight: '47px',
        borderBottom: '1px solid #f2f2f2',
      },
      a: { color: '#f2a40b' },
    },
    '.col-created-at': {},
    '.col-format': {},
    '.col-period': {},
    '.col-name': {},
    '.col-export-status': {},
  },
})
